/* 1500 Hours · v3 wear page (sections/h15-wear.liquid), 2026-10-13: hat, rope hat, hoodie, crewneck.

   ORDER DATA = the live native add: { id: variant, quantity: 1, properties: { Airport: <canonical code> } }, the
   line the h15-hats Worker (hats) and apparel/fulfill_apparel.py (hoodie / crewneck) read. The button only works
   once the render Worker has the field's art (hat ink for hats; card face + hat ink for garments), like
   hat-pdp.js / apparel-pdp.js. Hats: US addresses only. Hoodie / crewneck: locked before CFG.opensAt
   (?h15drop=1 opens it in this tab, ?h15drop=0 closes it). The card quick add matches hat-xsell.js. */
(function () {
  'use strict';
  var root = document.querySelector('.h15wear');
  if (!root) return;
  var CFG;
  try { CFG = JSON.parse(root.querySelector('.h15w-cfg').textContent); } catch (e) { return; }
  var PID = CFG.pid;
  if (!PID) return;

  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4); }
  // Shopify hands every price over in the visitor's currency (EUR in France, XOF in Togo ...), so the symbol has to come
  // from Shopify.currency, never a hardcoded "$" (2026-10-23: a Togo visitor read 21,000 XOF as "$21000"). US look unchanged.
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var NF = {};
  function money(c) {
    c = Math.round(c);
    var k = c % 100 ? 2 : 0;
    try {
      if (!NF[k]) NF[k] = new Intl.NumberFormat('en', { style: 'currency', currency: CUR, minimumFractionDigits: k, maximumFractionDigits: k });
      return NF[k].format(c / 100);
    } catch (e) { return (CUR === 'USD' ? '$' : CUR + ' ') + (k ? (c / 100).toFixed(2) : String(c / 100)); }
  }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v) localStorage.setItem(k, v); } catch (e) {} }

  var HAT = PID === 'hat' || PID === 'rope', GARM = PID === 'hoodie' || PID === 'crewneck';
  var ABROAD = HAT && CFG.country !== 'US';
  function gated() {
    if (!GARM) return false;
    try {
      var q = (location.search.match(/[?&]h15drop=([01])/) || [])[1];
      if (q === '1') sessionStorage.setItem('h15drop', '1');
      if (q === '0') sessionStorage.removeItem('h15drop');
      if (sessionStorage.getItem('h15drop') === '1') return false;
    } catch (e) {}
    var o = Date.parse(CFG.opensAt || '');
    return !!(o && Date.now() < o);
  }

  /* ---------- geometry: the same placements as the live PDP scripts (the blanks share their frame) ---------- */
  var HATBOX = 'left:25.81%;top:27.36%;width:48.46%;height:20.1%', ROPEBOX = 'left:29.58%;top:37.10%;width:40.85%;height:17.83%';
  var THREAD = { black: ['#f3f2ee', 'h15bThreadLight'], stone: ['#141414', 'h15bThreadDark'], white: ['#141414', 'h15bThreadDark'], ivory: ['#141414', 'h15bThreadDark'] };
  var GEO = {
    hoodie:   { back: { pct: [33.875, 19.312, 32.25, 42.938], pf: [1800, 2400], mask: true }, front: { pct: [35.5, 22.125, 29.125, 29.125], pf: [2100, 2100], chest: [1800, 330] } },
    crewneck: { back: { pct: [30.875, 11.625, 38.188, 50.812], pf: [1800, 2400] }, front: { pct: [30.875, 11.625, 38.188, 50.812], pf: [1800, 2400], chest: [1296, 210] } }
  };
  var SWATCH = { black: '#151515', stone: '#c9b9a3', white: '#f4f4f2', ivory: '#ece6d8' };
  function box(p, mask) { return 'left:' + p[0] + '%;top:' + p[1] + '%;width:' + p[2] + '%;height:' + p[3] + '%' + (mask ? ';-webkit-mask-image:url(' + mask + ');mask-image:url(' + mask + ')' : ''); }
  function hatArt(ink, color, bx) {
    var t = THREAD[color] || THREAD.black;
    return '<svg class="b-art" style="' + bx + '" viewBox="0 0 400 175" preserveAspectRatio="none" aria-hidden="true"><g fill="' + t[0] + '" filter="url(#' + t[1] + ')">' + ink + '</g></svg>';
  }
  function garmArt(g, side, face, ink) {
    var b = GEO[g][side], pf = b.pf;
    if (side === 'back') return face ? '<svg class="b-art" style="' + box(b.pct, b.mask ? CFG.mask : '') + '" viewBox="0 0 ' + pf[0] + ' ' + pf[1] + '" aria-hidden="true"><svg x="' + Math.round((pf[0] - 1466) / 2) + '" y="180" width="1466" height="2160" viewBox="18 40 176.5 260" preserveAspectRatio="none"><g fill="var(--bone)" font-family="Montserrat, sans-serif">' + face + '</g></svg></svg>' : '';
    return ink ? '<svg class="b-art" style="' + box(b.pct) + '" viewBox="0 0 ' + pf[0] + ' ' + pf[1] + '" aria-hidden="true"><svg class="b-chest" data-cx="' + b.chest[0] + '" data-top="' + b.chest[1] + '" x="0" y="0" width="0" height="0" viewBox="0 0 400 175" preserveAspectRatio="none"><g fill="var(--bone)">' + ink + '</g></svg></svg>' : '';
  }
  function fitChest(host) {
    $$('svg.b-chest', host).forEach(function (inner) {
      var g = inner.querySelector('g'), bb; try { bb = g.getBBox(); } catch (e) { return; }
      if (!bb || !bb.width) return;
      var w = 450, hh = w * bb.height / bb.width;
      inner.setAttribute('viewBox', bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
      inner.setAttribute('x', +inner.getAttribute('data-cx') - w / 2); inner.setAttribute('y', inner.getAttribute('data-top'));
      inner.setAttribute('width', w); inner.setAttribute('height', hh);
    });
  }

  /* ---------- Worker art ---------- */
  var KEEP = { polygon: ['points'], path: ['d', 'transform'], text: ['x', 'y', 'text-anchor', 'font-weight', 'font-size', 'letter-spacing'] };
  function safeArt(svg) {
    try {
      var doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
      if (doc.querySelector('parsererror')) return '';
      var out = '';
      [].slice.call(doc.querySelectorAll('polygon, path, text')).forEach(function (n) {
        var tag = n.tagName.toLowerCase(), a = '';
        KEEP[tag].forEach(function (k) { var v = n.getAttribute(k); if (v != null) a += ' ' + k + '="' + esc(v) + '"'; });
        out += tag === 'text' ? '<text' + a + '>' + esc(n.textContent) + '</text>' : '<' + tag + a + '/>';
      });
      return out;
    } catch (e) { return ''; }
  }
  var cache = {};
  function wget(path) { return fetch(CFG.endpoint + path, { credentials: 'omit' }); }
  // one promise per field: { disp, name, face, ink } or { miss: true }
  function art(code) {
    if (cache[code]) return cache[code];
    var p = Promise.all([wget('/?code=' + encodeURIComponent(code)), wget('/?m=hat&code=' + encodeURIComponent(code))]).then(function (rs) {
      var f = rs[0], h = rs[1];
      if (f.status === 404 || h.status === 404) return { miss: true };
      if (!f.ok || !h.ok) throw new Error('worker');
      var disp = clean(f.headers.get('x-h15-disp') || h.headers.get('x-h15-disp') || code), name = '';
      try { name = decodeURIComponent(h.headers.get('x-h15-name') || '').toLowerCase(); } catch (e) {}
      return Promise.all([f.text(), h.text()]).then(function (t) {
        var r = { disp: disp, name: name, face: safeArt(t[0]), ink: safeArt(t[1]) };
        if (!r.face || !r.ink) throw new Error('art');
        return r;
      });
    });
    cache[code] = p;
    p.catch(function () { delete cache[code]; });
    return p;
  }

  /* ---------- state ---------- */
  var V = CFG.variants;
  var opts = V.map(function (v) { return v.opt; });
  var qs = new URLSearchParams(location.search);
  var startV = +qs.get('variant') || 0;
  var first = V.filter(function (v) { return v.id === startV; })[0] || V.filter(function (v) { return v.available; })[0] || V[0] || {};
  var st = { code: '', typed: '', art: null, color: HAT ? first.opt : '', size: GARM && startV ? first.opt : '', side: PID === 'crewneck' ? 'front' : 'back' };
  var DEMO = 'KBJC';
  function variant() {
    if (HAT) return V.filter(function (v) { return v.opt === st.color; })[0] || V[0];
    return V.filter(function (v) { return v.opt === st.size; })[0] || null;
  }
  function shown() { return st.art || demoArt; }
  var demoArt = null;

  /* ---------- the stage ---------- */
  var STAGE = $('#h15w-stage'), CAP = $('#h15w-cap');
  function blankKey() { return HAT ? PID + '-' + st.color : (PID === 'hoodie' ? 'hoodie-' : 'crew-') + st.side; }
  function paintStage() {
    var a = shown(), artHtml = '';
    if (a) artHtml = HAT ? hatArt(a.ink, st.color, PID === 'hat' ? HATBOX : ROPEBOX) : garmArt(PID, st.side, a.face, a.ink);
    STAGE.innerHTML = '<img class="b-blank' + (PID === 'hat' ? ' b-mult' : '') + '" alt="" src="' + esc(CFG.blank[blankKey()]) + '">' + artHtml +
      (GARM ? '<div class="b-sidepick"><button type="button" data-side="back" aria-pressed="' + (st.side === 'back') + '">back</button><button type="button" data-side="front" aria-pressed="' + (st.side === 'front') + '">front</button></div>' : '');
    fitChest(STAGE);
    var v = variant() || V[0], cmp = v && v.compare > v.price;
    var ship = HAT ? 'free us shipping · us addresses only · made to order'
      : (CFG.country === 'US' ? 'free us shipping · made to order, about 1 to 2 weeks' : '$15 shipping · made to order, 2 to 5 weeks');
    CAP.textContent = (st.code ? st.code + ' · ' : a ? 'example ' + a.disp + ' · ' : '') + ship + (cmp ? ' · first run price until oct 21' : '');
  }

  /* ---------- options ---------- */
  var O = $('#h15w-opts');
  function buildOpts() {
    var h = '';
    if (HAT) h += '<div class="b-sec"><span class="b-lbl">color</span><div class="b-chips" role="radiogroup" aria-label="color">' + V.map(function (v) {
      return '<button type="button" role="radio" data-color="' + esc(v.opt) + '" aria-pressed="' + (st.color === v.opt) + '" aria-checked="' + (st.color === v.opt) + '"' + (v.available ? '' : ' disabled') + '><span class="b-sw" style="background:' + (SWATCH[v.opt] || '#ccc') + '"></span>' + esc(v.opt) + '</button>';
    }).join('') + '</div></div>';
    if (GARM) h += '<div class="b-sec"><span class="b-lbl">size</span><div class="b-chips" id="h15w-sizes" role="radiogroup" aria-label="size">' + V.map(function (v) {
      return '<button type="button" role="radio" data-size="' + esc(v.opt) + '" aria-pressed="' + (st.size === v.opt) + '" aria-checked="' + (st.size === v.opt) + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.opt) + '</button>';
    }).join('') + '</div></div>';
    O.innerHTML = h;
  }
  function paintPrice() {
    var v = variant() || V[0];
    if (!v) return;
    $('#h15w-price').innerHTML = money(v.price) + (v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '');
  }
  var BUY = $('#h15w-buyslot');
  function paintBuy() {
    var gate = $('#h15w-gate');
    if (gate) gate.hidden = !gated();
    if (ABROAD) { BUY.innerHTML = '<div class="b-warn">hats ship to us addresses only for now.</div><button type="button" class="b-btn" disabled>us addresses only</button>'; return; }
    if (HAT && !CFG.hatsLive) { BUY.innerHTML = '<button type="button" class="b-btn" disabled>coming soon</button>'; return; }
    if (gated()) { BUY.innerHTML = ''; return; }
    if (st.miss) { BUY.innerHTML = '<a class="b-btn" data-ask="' + esc(st.typed) + '" href="' + esc(mailto(st.typed)) + '">email us for ' + esc(st.typed) + '</a>'; return; }
    var v = variant(), label;
    if (GARM && !st.size) label = 'pick a size';
    else if (!st.code) label = 'type your airport';
    else label = 'add ' + st.code + ' ' + (PID === 'rope' ? 'rope hat' : PID) + ' · ' + money((v || V[0]).price);
    var ready = !!(st.code && st.art && v && v.available);
    BUY.innerHTML = '<button type="button" class="b-btn" id="h15w-add"' + (ready ? '' : ' aria-disabled="true"') + '>' + esc(label) + '</button>';
  }

  /* ---------- the field ---------- */
  var seq = 0, timer = 0;
  function setStatus(cls, html) { var e = $('#h15w-st'); e.className = 'b-st' + (cls ? ' b-' + cls : ''); e.innerHTML = html; }
  function mailto(code) {   // same subject as the card builder's "email us for <CODE>", so fastmail/sweep.py tags it "+"
    var L = ['airport: ' + code, 'for: ' + ({ hat: 'runway hat', rope: 'rope hat' }[PID] || PID)];
    if (st.color) L.push('color: ' + st.color);
    if (st.size) L.push('size: ' + st.size);
    return 'mailto:' + CFG.email + '?subject=' + encodeURIComponent(code + ' request') +
      '&body=' + encodeURIComponent('hi,\n\nyou don\'t have ' + code + ' yet. could you draw it and send me a proof? i\'ll order once it looks right.\n\n' + L.join('\n') + '\n\n');
  }
  function lookup(v) {
    var my = ++seq;
    art(v).then(function (a) {
      if (my !== seq) return;
      if (a.miss) {
        st.code = ''; st.art = null; st.miss = v.length >= 4;
        setStatus(v.length >= 4 ? 'miss' : '', v.length >= 4 ? 'we don’t have ' + esc(v) + ' yet. <a data-ask="' + esc(v) + '" href="' + esc(mailto(v)) + '">email us</a> and we’ll draw it.' : 'keep typing…');
      } else {
        st.code = a.disp; st.art = a; lsSet('h15.airport', a.disp);
        setStatus('ok', esc(a.disp) + (a.name ? ' · ' + esc(a.name) : ''));
      }
      paintAll();
    }, function () {
      if (my !== seq) return;
      st.code = ''; st.art = null;
      setStatus('', 'can’t draw a preview right now. try again in a moment.');
      paintAll();
    });
  }
  root.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('[data-ask]'); if (a) a.setAttribute('href', mailto(a.getAttribute('data-ask'))); });
  var input = $('#h15w-ap');
  input.addEventListener('input', function () {
    var v = clean(input.value); if (input.value !== v) input.value = v;
    st.typed = v; st.code = ''; st.art = null; st.miss = false; clearTimeout(timer); clearMsg();
    if (!v) { setStatus('', 'type your field'); paintAll(); return; }
    if (v.length < 3) { setStatus('', 'keep typing…'); paintAll(); return; }
    setStatus('', 'checking ' + esc(v) + '…');
    timer = setTimeout(function () { lookup(v); }, 260);
  });
  input.addEventListener('blur', function () { if (st.code && clean(input.value) !== st.code) input.value = st.code; });
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });

  /* ---------- clicks ---------- */
  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-side]'))) { st.side = t.getAttribute('data-side'); paintStage(); return; }
    if ((t = e.target.closest('[data-color]'))) {
      st.color = t.getAttribute('data-color');
      $$('[data-color]').forEach(function (x) { var on = x === t; x.setAttribute('aria-pressed', String(on)); x.setAttribute('aria-checked', String(on)); });
      paintStage(); paintPrice(); paintBuy(); return;
    }
    if ((t = e.target.closest('[data-size]'))) {
      st.size = t.getAttribute('data-size');
      $$('[data-size]').forEach(function (x) { var on = x === t; x.setAttribute('aria-pressed', String(on)); x.setAttribute('aria-checked', String(on)); });
      var sz = $('#h15w-sizes'); if (sz) sz.classList.remove('b-bad');
      paintPrice(); paintBuy(); clearMsg(); return;
    }
    if (e.target.closest('#h15w-add')) { add(); return; }
    if (e.target.closest('#h15w-quick')) { quickCard(); }
  });

  /* ---------- cart ---------- */
  function err(m) { $('#h15w-err').textContent = m; }
  function clearMsg() { $('#h15w-err').textContent = ''; }
  function post(items, done) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || ('cart ' + r.status)); return j; }); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.ok ? c.json() : null; }); })
      .then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart || {}, sourceId: 'h15-wear', data: { source: 'product-form-component', itemCount: (cart && cart.item_count) || 0 } } })); } catch (e) {}
        var d = $('#h15w-done'); d.hidden = false; d.innerHTML = esc(done) + ' <a href="/cart">view bag →</a>';
        try { var dr = document.querySelector('cart-drawer-component'); if (dr && typeof dr.open === 'function') dr.open(); } catch (e) {}
      });
  }
  var busy = false;
  function add() {
    if (busy) return;
    clearMsg();
    if (GARM && !st.size) { var sz = $('#h15w-sizes'); if (sz) sz.classList.add('b-bad'); err('pick a size.'); return; }
    if (!st.code || !st.art) { err(st.typed ? 'we need a field we can draw. check the code above.' : 'type your airport first.'); input.focus(); return; }
    var v = variant();
    if (!v || !v.available) { err('that one is sold out.'); return; }
    busy = true;
    var b = $('#h15w-add'); b.textContent = 'adding…';
    post([{ id: v.id, quantity: 1, properties: { Airport: st.code } }], 'added to your bag.')
      .catch(function (e) { err('that didn’t go through: ' + String(e.message || e).toLowerCase() + '. try again?'); })
      .then(function () { busy = false; paintBuy(); });
  }
  function quickCard() {
    var code = st.code || (shown() && shown().disp);
    if (!code || !CFG.card.variant) return;
    var q = $('#h15w-quick'); q.disabled = true; q.textContent = 'adding…';
    post([{ id: CFG.card.variant, quantity: 1, properties: { Airport: code, _has_gpo: String(CFG.card.gpo || '') } }], code + ' card added.')
      .then(function () { q.textContent = 'added'; }, function (e) { q.disabled = false; q.textContent = 'add'; err('that didn’t go through: ' + String(e.message || e).toLowerCase()); });
  }

  /* ---------- the field's card + the rest ---------- */
  var RING = '<image href="' + esc(CFG.ring) + '" x="-53.85" y="214.15" width="111.70" height="111.70" filter="url(#h15b-ring-sh)"/><g clip-path="url(#h15b-rc)"><rect width="212.5" height="337" rx="12.5" fill="#000" opacity=".6" filter="url(#h15b-ring-cast)"/></g>';
  function cardSvg(face) {
    return '<svg viewBox="0 0 212.5 337" aria-hidden="true">' + RING + '<g mask="url(#h15b-hole)"><rect width="212.5" height="337" rx="12.5" fill="var(--metal)"/><rect width="212.5" height="337" rx="12.5" fill="url(#h15b-light)"/>' +
      '<g fill="var(--etch)" font-family="Montserrat, sans-serif">' + face + '</g><rect width="212.5" height="337" rx="12.5" fill="#fff" filter="url(#h15b-grain)" opacity=".05"/>' +
      '<rect x=".6" y=".6" width="211.3" height="335.8" rx="11.9" fill="none" stroke="url(#h15b-edge)" stroke-width="1.2"/></g></svg>';
  }
  function paintCard() {
    var a = shown(), th = $('#h15w-cardth'); if (!th || !a) return;
    th.innerHTML = cardSvg(a.face);
    $$('[data-code]').forEach(function (s) { s.textContent = a.disp; });
    var l = $('#h15w-cardlink'); if (l && CFG.card.url) l.setAttribute('href', CFG.card.url + '?airport=' + encodeURIComponent(a.disp));
    var q = $('#h15w-quick'); if (q && !q.disabled) q.textContent = 'add';
  }
  var CUTBOX = { hat: HATBOX, rope: ROPEBOX };
  function paintRest() {
    var a = shown(), host = $('#h15w-strip'), sec = $('#h15w-rest');
    var list = (CFG.rest || []).filter(function (w) { return w.pid !== PID && w.url && w.available && !((w.pid === 'hat' || w.pid === 'rope') && (CFG.country !== 'US' || !CFG.hatsLive)); });
    if (!list.length || !a) { sec.hidden = true; return; }
    sec.hidden = false;
    var o = Date.parse(CFG.opensAt || ''), locked = o && Date.now() < o;
    host.style.gridTemplateColumns = 'repeat(' + list.length + ',minmax(0,1fr))';
    host.innerHTML = list.map(function (w) {
      var artHtml = w.pid === 'hat' || w.pid === 'rope' ? hatArt(a.ink, w.pid === 'hat' ? 'black' : 'ivory', CUTBOX[w.pid]) : garmArt(w.pid, w.pid === 'crewneck' ? 'front' : 'back', a.face, a.ink);
      var price = (w.pid === 'hoodie' || w.pid === 'crewneck') && locked ? 'oct 14' : money(w.price);
      return '<a href="' + esc(w.url) + '?airport=' + encodeURIComponent(a.disp) + '"><div class="b-wstage"><div class="b-obj"><img class="b-blank" alt="" src="' + esc(CFG.cut[w.pid]) + '">' + artHtml + '</div></div><span>' + esc(w.name) + '</span><span class="b-pr">' + price + '</span></a>';
    }).join('');
    fitChest(host);
  }
  function paintTabs() {
    $$('.b-kinds a[data-tab]').forEach(function (t) {
      var href = t.getAttribute('href').split('?')[0];
      t.setAttribute('href', href + (st.code ? '?airport=' + encodeURIComponent(st.code) : ''));
    });
  }
  function paintAll() { paintStage(); paintPrice(); paintBuy(); paintCard(); paintRest(); paintTabs(); }

  /* ---------- start ---------- */
  buildOpts();
  paintAll();
  var uc = qs.get('utm_content') || '';
  var start = clean(qs.get('airport') || (/^[a-z0-9]{3,4}$/i.test(uc) ? uc : '') || lsGet('h15.airport') || '');
  art(DEMO).then(function (a) { if (!a.miss) { demoArt = a; if (!st.art) paintAll(); } }, function () {});
  if (start.length >= 3) { input.value = start; st.typed = start; setStatus('', 'checking ' + esc(start) + '…'); lookup(start); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitChest(root); });
})();
